import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { SelectedSexContextProvider } from "./store/selectedSex-context";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <SelectedSexContextProvider>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </SelectedSexContextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
